import(/* webpackMode: "eager" */ "/app/apps/web/app/(public)/product/usali/page.tsx");
